import React from "react";
import Paper from "apollo-react/components/Paper";
import Typography from "apollo-react/components/Typography";
import DateRangePicker from "apollo-react/components/DateRangePicker";
import { shouldShowStatusFilters } from "./tabUtils";
import "./styles.css";

const FiltersPanel = ({ 
  filters, 
  onFilterChange, 
  onApplyFilters, 
  currentTab, 
  isCoreValidator, 
  persona 
}) => {
  const showStatusFilters = shouldShowStatusFilters(persona, currentTab, isCoreValidator);

  return (
    <Paper className="filter-container">
      <Typography
        variant="body2"
        className="filter-title"
      >
        Filter
      </Typography>
      
      {/* Reference Number/Study Name Filter */}
      <Typography variant="body2" className="filter-label">
        Reference Number/Study Name
      </Typography>
      <input
        type="text"
        placeholder="Search by reference number or study name"
        className="filter-input"
        value={filters.referenceOrStudyName}
        onChange={(e) => onFilterChange('referenceOrStudyName', e.target.value)}
      />

      {/* Date Range Filter */}
      <Typography variant="body2" className="filter-label">
        Date Range
      </Typography>
      <div className="filter-date-container">
        <DateRangePicker
          value={filters.dateRange}
          onChange={(dateRange) => onFilterChange('dateRange', dateRange)}
          style={{ width: "100%" }}
        />
      </div>

      {/* Status Filter for specific tabs */}
      {showStatusFilters && (
        <>
          <Typography variant="body2" className="filter-label" style={{ marginTop: "8px" }}>
            Status
          </Typography>
          <div className="radio-container">
            <div className="radio-item">
              <input
                type="radio"
                id="all"
                name="statusFilter"
                value="all"
                checked={filters.statusFilter === "all"}
                onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                className="radio-input"
              />
              <label htmlFor="all" className="radio-label">
                All
              </label>
            </div>
            
            {persona === "committee" ? (
              <>
                <div className="radio-item">
                  <input
                    type="radio"
                    id="approved"
                    name="statusFilter"
                    value="approved"
                    checked={filters.statusFilter === "approved"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="approved" className="radio-label">
                    Approved
                  </label>
                </div>
                
                <div className="radio-item">
                  <input
                    type="radio"
                    id="rejected"
                    name="statusFilter"
                    value="rejected"
                    checked={filters.statusFilter === "rejected"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="rejected" className="radio-label">
                    Rejected
                  </label>
                </div>
                
                <div className="radio-item">
                  <input
                    type="radio"
                    id="in-progress"
                    name="statusFilter"
                    value="in-progress"
                    checked={filters.statusFilter === "in-progress"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="in-progress" className="radio-label">
                    In Progress
                  </label>
                </div>
              </>
            ) : (
              <>
                <div className="radio-item">
                  <input
                    type="radio"
                    id="technical-validator"
                    name="statusFilter"
                    value="technical"
                    checked={filters.statusFilter === "technical"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="technical-validator" className="radio-label">
                    Technical Validator
                  </label>
                </div>
                
                <div className="radio-item">
                  <input
                    type="radio"
                    id="business-validator"
                    name="statusFilter"
                    value="business"
                    checked={filters.statusFilter === "business"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="business-validator" className="radio-label">
                    Business Validator
                  </label>
                </div>
                
                <div className="radio-item">
                  <input
                    type="radio"
                    id="core-validator"
                    name="statusFilter"
                    value="core"
                    checked={filters.statusFilter === "core"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="core-validator" className="radio-label">
                    Core Validator
                  </label>
                </div>
                
                <div className="radio-item">
                  <input
                    type="radio"
                    id="pricing"
                    name="statusFilter"
                    value="pricing"
                    checked={filters.statusFilter === "pricing"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="pricing" className="radio-label">
                    Pricing
                  </label>
                </div>
                
                <div className="radio-item">
                  <input
                    type="radio"
                    id="ra"
                    name="statusFilter"
                    value="ra"
                    checked={filters.statusFilter === "ra"}
                    onChange={(e) => onFilterChange('statusFilter', e.target.value)}
                    className="radio-input"
                  />
                  <label htmlFor="ra" className="radio-label">
                    Committee
                  </label>
                </div>
              </>
            )}
          </div>
        </>
      )}

      {/* Action Buttons */}
      <button className="filter-button" onClick={onApplyFilters}>
        Filter
      </button>
    </Paper>
  );
};

export default FiltersPanel;
